export default {
    namespaced: true,
    state: {
        devicePrefersDark: null,
    },
    getters: {
        isDarkTheme({devicePrefersDark}, _, { options }) {
            switch (options.theme) {
                case 1: return true;
                case 2: return false;
                default: return devicePrefersDark;
            }
        },
    },
    mutations: {
        update(state, value) {
            state.devicePrefersDark = value;
        },
    },
};